export class Base64Util {
  static encode(str?: string) {
    if (!str) return;
    try {
      return btoa(str);
    } catch (e) {
      return;
    }
  }

  static decode(base64Str?: string | null) {
    if (!base64Str) return;
    try {
      return atob(base64Str);
    } catch (e) {
      return;
    }
  }

  static isBase64Encoded(str?: string | null) {
    if (!str) return;
    try {
      // Attempt to decode the string
      const decodedStr = atob(str);
      // Check if the decoded string can be re-encoded to the original
      // This helps to filter out strings that are not valid Base64 but can still be decoded without error
      return btoa(decodedStr) === str;
    } catch (e) {
      // If an error occurs during decoding, it's not valid Base64
      return false;
    }
  }
}
